import Header from '../home/header.js'
import Aboutheader from './aboutheader.js'
import Services from '../home/services';
// import Parallaxview from './components/parallaxview';
import Contactnow from '../home/contactnow';
import Faq from '../home/faq';
import ServiceDescription from '../home/servicesDescription';
import Technologies from '../home/technologies';
import Testimonials from '../home/testimonial';
import HowwebuildProject from '../home/howwebuildProject';

import Footer from '../home/footer';const aboutpage=()=>{
    return(
        <>
            <Header/>  
            <Aboutheader/>
            <Services/>
            <ServiceDescription/>
            <Technologies/>
            <HowwebuildProject/>
            <Testimonials/>
            {/* <Faq/> */}
            <Contactnow/>
            <Footer/>
        </>
    )
}
export default aboutpage